import { render, staticRenderFns } from "./CommissionableProducts.vue?vue&type=template&id=1392b684&"
import script from "./CommissionableProducts.vue?vue&type=script&lang=js&"
export * from "./CommissionableProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports